import { Flex, Spinner } from "@chakra-ui/react";
import { useState } from "react";
import { Icon } from "assets/Icon";
import { Button } from "newui/components/Button";
import { downloadAllAddendumFiles } from "../addendum.api";
import { Attachment } from "../addendum.types";

type DownloadAllAddendumFilesProps = {
	questionId: number | string;
	attachments?: Attachment[];
	canDownloadAll?: boolean;
};

export const DownloadAllAddendumFiles = ({
	questionId,
	attachments,
	canDownloadAll,
}: DownloadAllAddendumFilesProps) => {
	const [downloadLoading, setDownloadLoading] = useState(false);

	// canDownloadAll is authoritative — the API sets it alongside `attachments` and it
	// already accounts for the published check. The length fallback only covers responses
	// that omit the flag entirely.
	const shouldShow = canDownloadAll ?? (attachments?.length ?? 0) > 1;

	if (!shouldShow) {
		return null;
	}

	const downloadAllHandler = () => {
		setDownloadLoading(true);
		downloadAllAddendumFiles(questionId).finally(() => {
			setDownloadLoading(false);
		});
	};

	return (
		<Button
			btntype="secondary"
			disabled={downloadLoading}
			onClick={downloadAllHandler}
			data-testid="download-all-addendum-files"
		>
			{!downloadLoading ? (
				<Flex align={"center"} gap={2}>
					<Icon icon="download" color="#0031DD" />
					Download All
				</Flex>
			) : (
				<Spinner size="md" />
			)}
		</Button>
	);
};
